/**
 * @description: 收银交接汇总报表
 * @author: hwx
 * @update: lyr
*/
<template>
    <div class="sjh-report">
        <div class="sjh-list">
            <p class="p-hint">注：1、交接款数据为营业额，现金、刷卡消费等为其具体支付类型。2、会员充值办卡不计入营业额，管理员充值等为会员充值具体类型</p>
            <div class="row row-margin">
                <label class="list-label-2">时间:</label>
                <div class="col-md-3 list-time">
                    <div ref="sjhTime">
                        <input type="text" class="form-control laydate-icon" v-model="sjhStartTime"> -
                        <input type="text" class="form-control laydate-icon" v-model="sjhEndTime">
                    </div>
                </div>
                <label class="list-label-2">门店:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="sjh_shop" data-placeholder="请选择消费门店"></select>
                </div>
                <div>
                    <el-button :type="tableType == 1 ? 'primary' : ''" @click="changeTableType(1)" size="small">交接班</el-button>
                    <el-button :type="tableType == 2 ? 'primary' : ''" @click="changeTableType(2)" size="small">营业收入交接</el-button>
                    <el-button type="primary" @click="getSjhList(1)" size="small">查询</el-button>
                    <el-button type="primary" @click="getSjhExportSet" size="small">导出</el-button>
                </div>
            </div>
            <el-table
                v-loading="loading"
                element-loading-text="努力加载中，请稍后..."
                element-loading-background="rgba(0, 0, 0, 0.6)"
                :data="sjh_list_table"
                :key="tableKey">
                <el-table-column
                    v-for="(item, index) in sjh_column_tit"
                    :fixed="item.fixed"
                    :key="index"
                    :prop="item.prop"
                    :label="item.label"
                    :width="item.width">
                </el-table-column>
            </el-table>
            <el-pagination
                background
                layout="total, prev, pager, next, jumper"
                :page-size="GLOBAL.PAGESIZE"
                :current-page.sync="sjh_list_page"
                :total="sjh_list_total"
                @current-change="getSjhList">
            </el-pagination>
            <!-- <div class="table-responsive">
                <table class="table table-bordered table-hover" data-pagination="true" ref="sjhList"></table>
            </div> -->
            <!-- 导出设置弹窗 -->
            <div class="ele-hide" ref="sjhExport_alert">
                <div class="set-export sel-seldiv">
                    <h3>请选择导出报表需要的显示的字段</h3>
                    <ul class="set-area clearfix">
                        <li>
                            <input type='checkbox' v-model='sjhExport_allcheck' @click='sjhExportCheckedAll'>
                            <label>全选</label>
                        </li>
                        <li v-for="item in sjhExport_checkData" :key="item.key">
                            <input type="checkbox" v-model='sjhExport_checkModel' :value="item.key">
                            <label>{{item.name}}</label>
                        </li>
                    </ul>
                    <h3>请选择导出报表的文件格式</h3>
                    <ul class="clearfix">
                        <li>
                            <input type="radio" v-model='sjhExport_type' value="1">
                            <label>excel表格</label>
                        </li>
                        <li>
                            <input type="radio" v-model='sjhExport_type' value="2">
                            <label>pdf文件</label>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    export default {
        name: '',
        data() {
            return {
                loading: false,
                sjhStartTime: "",
                sjhEndTime: "",
                sjhExport_allcheck: false,
                c_sjhExport_allcheck: false,
                sjhExport_checkModel: [],
                sjhExport_checkData: [],
                sjhExport_type: 1,
                sjhColumns: [],
                sjh_list_page: 1,
                sjh_list_total: 0,
                sjh_list_table: [],
                sjh_column_tit: [],
                tableType: 1, // 1交接班 2营业收入交接
                tableKey: Math.random(),
            }
        },
        watch: {
            sjhExport_checkModel: {
                handler: function (val, oldVal) {
                    if(this.sjhExport_checkModel.length >= this.sjhExport_checkData.length) {
                        this.sjhExport_allcheck = true;
                        this.c_sjhExport_allcheck = true;
                    } else {
                        this.sjhExport_allcheck = false;
                        this.c_sjhExport_allcheck = false;
                    }
                },
                deep: true
            },
        },
        mounted: function() {
            // 日期
            this.sjhStartTime = moment().format('YYYY-MM-DD');
            this.sjhEndTime = moment().add(1, 'day').format('YYYY-MM-DD');
            // 获取缓存
            let sjh_report_localStorage = JSON.parse(localStorage.getItem('sjh_table_type'));
            if(sjh_report_localStorage && sjh_report_localStorage.mobile == this.$store.state.usermobile) {
                this.tableType = sjh_report_localStorage.table_type;
            }
            this.innitDate();
            this.shopDatas = [];
            this.innitInput();  // 门店
            this.listShow10 = true;
        },
        methods: {
            setShopDefaultTime(shop_id) {
                let report_default_time = '1'
                let shop_report_default_time = this.$store.state.shop_report_default_time
                shop_report_default_time.forEach(item => {
                    if (shop_id == item.shop_id) {
                        report_default_time = item.report_default_time
                        if (report_default_time == '1') {
                            this.sjhStartTime = moment().format('YYYY-MM-DD');
                            this.sjhEndTime = moment().add(1, 'day').format('YYYY-MM-DD');
                        }else {
                            this.sjhStartTime = moment().subtract(1, 'day').format('YYYY-MM-DD');
                            this.sjhEndTime = moment().format('YYYY-MM-DD');
                        }
                    }
                })
            },
            // 初始化日期插件
            innitDate: function() {
                let _this = this;
                $(_this.$refs.sjhTime).daterangepicker({
                    buttonClasses: ['btn btn-default'],
                    applyClass: 'btn-small btn-orange',
                    cancelClass: 'btn-small btn-gray',
                    startDate: moment().toDate(),
                    endDate: moment().add(1, 'day').toDate(),
                    dateLimit: {
                        days: 31
                    },
                }, function(start, end, label) {
                    _this.sjhStartTime = start.format('YYYY-MM-DD');
                    _this.sjhEndTime = end.format('YYYY-MM-DD');
                });
            },
            // 初始化门店输入框
            innitInput: function() {
                let _this = this;

                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": "1",
                            "page_size": "0",
                            "name": "",
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "PublicData/api_getShopListByPurview",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            $.each(data.response.result, function(k, v) {
                                _this.shopDatas.push({
                                    id: v.id,
                                    text: v.name
                                });
                            });
                            _this.shopDatas.shift();
                            $(_this.$refs.sjh_shop).select2({
                                data: _this.shopDatas,
                                allowClear: true,
                                minimumResultsForSearch: -1,
                                language: "zh-CN"
                            }).on("select2:select", function(e) {
                                _this.setShopDefaultTime(e.params.data.id)
                            });
                            _this.setShopDefaultTime(data.response.result[1].id)
                            _this.getSjhList(1);
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },



            getSjhList(page) {
				const _this = this;

                _this.loading = true;
                _this.sjh_list_page = page
                let url = 'FinanceReport2/getShiftTurnoverSumList'
                if(_this.tableType == 2) {
                    url = 'FinanceReport2/getShopShiftTurnoverSumList'
                }
				Vue.axios.post(url, {
					"header": Vue.request_header,
					"request": {
						"param": {
							"page": page,
							"page_size": _this.GLOBAL.PAGESIZE,
                            "start_date": _this.sjhStartTime,
                            "end_date": _this.sjhEndTime,
                            "shop_id": $(_this.$refs.sjh_shop).val()
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(page == 1) {
							_this.sjh_list_total = Number(res.data.response.result.count);
                            _this.sjh_column_tit = [];
                            _this.sjhExport_checkData = [];
                            for(let [key, value] of Object.entries(res.data.response.result.column_arr)) {
                                if(key == 'free_amount' || key == 'recharge_free_amount' || key.indexOf('custom_') > -1) {
                                    _this.sjh_column_tit.push({ prop: key, label: value, width: '110' });
                                } else if(key == 'vip_turnover') {
                                    _this.sjh_column_tit.push({ prop: key, label: value, width: '120' });
                                } else {
                                    _this.sjh_column_tit.push({ prop: key, label: value, width: 'auto' });
                                }
                                _this.sjhExport_checkData.push({ key: key, name: value });
                            }
						}
						_this.sjh_list_table = res.data.response.result.data;
						_this.loading = false;
                        _this.tableKey = Math.random();
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
			},

            changeTableType(type) {
                this.tableType = type;
                this.getSjhList(1);
                // 缓存本地
                let sjh_report_localStorage = {
                    "table_type": type,
                    "mobile": this.$store.state.usermobile
                }
                localStorage.setItem('sjh_table_type', JSON.stringify(sjh_report_localStorage));
            },

            // 获取导出设置
            getSjhExportSet: function() {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "report_type": _this.tableType == 1 ? 'FinanceReport2/shiftTurnoverSumExport' : 'FinanceReport2/shopShiftTurnoverSumExport'
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "FinanceReport/getExportSet",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            if(data.response.result) {
                                _this.sjhExport_checkModel = data.response.result.export_fields;
                                _this.sjhExport_type = data.response.result.export_type;
                            } else {
                                _this.sjhExport_checkModel = [];
                                _this.sjhExport_checkData.forEach(function(item) {
                                    _this.sjhExport_checkModel.push(item.key);
                                });
                                _this.sjhExport_type = 1;
                            }
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });

                // 弹窗
                layer.confirm('', {
                    skin: 'add_printer_area',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['导出设置', true],
                    area: ['830px', ''], // 宽高
                    content: $(_this.$refs.sjhExport_alert)
                }, function() {
                    _this.exportSjhList();
                });
            },
            // 导出字段全选
            sjhExportCheckedAll: function() {
                let _this = this;
                _this.sjhExport_allcheck = _this.c_sjhExport_allcheck;
                if(!_this.sjhExport_allcheck) { // 实现全选
                    _this.sjhExport_checkModel = [];
                    _this.sjhExport_checkData.forEach(function(item) {
                        _this.sjhExport_checkModel.push(item.key);
                    });
                } else { // 实现反选
                    _this.sjhExport_checkModel = [];
                }
            },
            // 导出
            exportSjhList: function() {
                let _this = this;

                if(_this.sjhExport_checkModel.length == '0') {
                    layer.msg('导出字段不能为空');
                    return false;
                }
                let export_fields = JSON.stringify(_this.sjhExport_checkModel);
                let url = _this.tableType == 1 ? 'FinanceReport2/shiftTurnoverSumExport' : 'FinanceReport2/shopShiftTurnoverSumExport'
                window.location.href = Vue.ctUrl + url + "?" +
                    "&start_date=" + _this.sjhStartTime +
                    "&end_date=" + _this.sjhEndTime +
                    "&shop_id=" + $(_this.$refs.sjh_shop).val() +
                    "&export_fields=" + export_fields +
                    "&export_type=" + _this.sjhExport_type;
                layer.msg("导出成功！");
                layer.closeAll();
            },
        }
    }
</script>
<style lang="less" scoped>
    
</style>